import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getInitFormData,
  getTablebySql,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SharedForm from "@widgets/SharedForm";

interface popupProps {
  selectedData?: any;
  Menuprops?: any;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_PRD_WMO_REG_001_POP_01 = forwardRef(
  ({ selectedData, Menuprops }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const today = new Date();
    const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
    const [columns1, setColums1] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const SharedFormref1 = useRef<any>();
    //#endregionconst SharedFormref1 = useRef<any>();
    const gridref1 = useRef<any>(null);
    const [focusedRowData, setFocusedRowData] = useState<any>();
    const [sharedForm, setSharedForm] = useState<any[]>([]);

    useImperativeHandle(ref, () => ({
      getSelectedValue: () => {
        onSave();
        return "success"; // 리턴값이 필요해서 아무거나 보냄 의미없음
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitFormData();
          setSharedForm(rtn.form.freeform1);
          setColums1(rtn.grid.grid4); // H그리드 항목 설정

          await onSearch();
        } catch (error) {}
      };
      fetchform();
    }, []);
    const onSearch = async () => {
      try {
        const params = {
          id: "sn_prd_wmo_reg_001_pop_01_01",
          params: { cd_firm: userInfo.cd_firm, no_wo: selectedData.no_wo },
        };

        setDataSource1([]);

        const data: any = await fnGetDataSet(params);
        setDataSource1(data[0]);

        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          gridref1.current.selectAndFocusRow(0);
          gridref1.current.resetUpdate();
        } else {
          await onAddRow();
        }
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    //#region OnSave
    const onSave = async () => {
      let prdWoSpec;
      prdWoSpec = gridref1.current.getChange();

      if (prdWoSpec.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const SaveData = {
        prd_wo_spec: prdWoSpec,
      };

      await fnSave("SN_PRD_WMO_REG_001_POP_SAVE_01", SaveData);

      gridref1.current?.resetUpdate();
    };
    const onAddRow = async () => {
      const newRow = {};
      const sqlQuery = {
        sql: "select m.cd_biz, m.cd_item, i.nm_item, i.dc_item_spec,i.dc_item_unit from prd_wo m left outer join mas_item i on m.cd_firm = i.cd_firm and m.cd_item = i.cd_item where m.cd_firm = :cd_firm and m.no_wo = :no_wo",
        cd_firm: userInfo.cd_firm,
        no_wo: selectedData.no_wo,
      };
      const params = await getTablebySql(sqlQuery);
      if (params.length > 0) {
        gridref1.current?.addRow({
          cd_biz: params[0]?.cd_biz,
          cd_item: params[0]?.cd_item,
          nm_item: params[0]?.nm_item,
          dc_item_spec: params[0].dc_item_spec,
          dc_item_unit: params[0].dc_item_unit,
          newRow,
        });
      } else {
        gridref1.current?.addRow(newRow);
      }
    };
    const onBeforeAddRowH = (newRow: RowData): boolean => {
      try {
        const updatedRow = {
          cd_firm: userInfo.cd_firm,
          cd_user_reg: userInfo.cd_user,
          dt_reg: todayform,
          no_wo: selectedData.no_wo,
        };
        Object.assign(newRow, updatedRow); // 원본 객체 수정

        return true;
      } catch (error: any) {
        showDialog("error", error.message);
        return false; // 추가 취소
      }
    };
    const onFocusedRowChanged = useCallback(
      (focusedRowData: any | null) => {
        setFocusedRowData(focusedRowData);
      },
      [focusedRowData]
    );
    return (
      <div>
        <div>
          <div style={{ height: "40vh", marginTop: "10px" }}>
            <SharedForm
              ref={SharedFormref1}
              data={focusedRowData}
              controls={sharedForm}
              gridref={gridref1}
              
            />

            <div style={{ height: 0, width: 0 }}>
              <SnGrid
                ref={gridref1}
                enableAddRow={true}
                isEditable={true}
                columnConfig={columns1}
                rowData={dataSource1}
                onFocusedRowChanged={onFocusedRowChanged}
                onBeforeAddRow={onBeforeAddRowH}
                rowSelection="single"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WMO_REG_001_POP_01;
